<template>
    <div class="notification" :class="what">
        <div class="title">{{ $t(title) }}</div>
        <div class="message">{{ $t(message) }}</div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            default: '',
        },
        what: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style lang="scss">
.notification {
    position: fixed;
    right: 20px;
    top: 20px;
    width: 350px;
    z-index: 1000;
    background: white;
    border-radius: 20px;
    padding: 22px;

    .title {
        font-weight: bold;
        font-size: 16px;
        line-height: 1.3;
        margin-bottom: 3px;
    }
    .message {
        font-size: 14px;
        line-height: 1.4;
    }

    &.error {
        .title {
            color: $color-danger;
        }
    }
    &.success {
        .title {
            color: $color-success;
        }
    }
}
</style>
